import { createI18n } from 'vue-i18n'

function loadTranslationFiles() {
	const translationFiles = require.context('../i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i)
	const messages = {}
	translationFiles.keys().forEach(key => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = translationFiles(key)
		}
	})
	return messages
}

export default createI18n({
	legacy: false,
	locale: navigator.language.split('-')[0],
	fallbackLocale: 'en',
	messages: loadTranslationFiles()
})